import { createBrowserRouter  } from "react-router-dom"
import { Header } from "./components/Header";
import { Favoritos } from "./pages/Favoritos";
import { Filme } from "./pages/Filme";
import { Home } from "./pages/Home";
import { Error } from "./pages/Error";



export const Router = createBrowserRouter([

    {
      path:'/',
      element: <Home/>
    },
    {
      path:'/favoritos',
      element: <Favoritos/>
    },
    {
      path:'/filme/:id',
      element: <Filme/>
    },
    {
      path:'*',
      element:<Error/>
    }
])  